<template>
	<div class="todo-statistic">
		<legend @click.stop="navigateTodo()" class="font-medium text-black text-lg font-medium mb-2 cursor-pointer">{{ title }}</legend>
		<vue-apex-charts :height="350" :options="localChartOptions" :series="localSeries" />
	</div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "TodoStatistic",
	components: {
		VueApexCharts
	},
	props: {
		title: String,
		data: {
			type: Array,
			required: true
		},
		labels: {
			type: Array,
			required: true
		},
		department: {
			type: Number
		}
	},
	computed: {
		localSeries() {
			return this.data;
		},
		localChartOptions() {
			return {
				colors: ["#EB5757", "#2B59B2", "#219653"],
				chart: {
					type: "pie"
				},
				legend: {
					position: "bottom",
					formatter: function(seriesName, opts) {
						return `<span>${opts.w.globals.series[opts.seriesIndex]}</span>`;
					}
				},
				labels: this.labels,
				responsive: [
					{
						breakpoint: 650,
						options: {
							chart: {
								width: 200
							}
						}
					},
					{
						breakpoint: 320,
						options: {
							chart: {
								width: 150
							}
						}
					}
				]
			};
		}
	},
	methods: {
		navigateTodo() {
			this.$router.push({
				name: this.$constant.PAGES_NAME.PAGE_CBS_TODO_NAME,
				params: { department_ids: [this.department] }
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.todo-statistic {
	border: 1px solid var(--color-gray-5);
	border-radius: 8px;
	padding: 20px;

	::v-deep .apexcharts-canvas {
		left: 50%;
		transform: translateX(-50%);
	}

	::v-deep .apexcharts-legend {
		flex-direction: row;
		padding: 0;
		justify-content: space-between !important;
		align-items: center !important;

		.apexcharts-legend-series {
			// &:not(:last-child) {
			// 	// margin-bottom: 8px !important;
			// 	box-sizing: border-box;
			// 	width: 25px !important;
			// }
		}

		.apexcharts-legend-marker {
			// margin-right: 8px;
			box-sizing: content-box;
			width: 22px !important;
			// height: 25px !important;
			// border-radius: 50% !important;
		}

		.apexcharts-legend-text {
			display: flex;
			width: 100%;
			justify-content: space-between;
			font-size: 1rem !important;
		}
	}
}
</style>
